var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 8.66675H23.3466M9.33329 2.66675H22.6666C26.3485 2.66675 29.3333 5.65152 29.3333 9.33342V22.6667C29.3333 26.3486 26.3485 29.3334 22.6666 29.3334H9.33329C5.65139 29.3334 2.66663 26.3486 2.66663 22.6667V9.33342C2.66663 5.65152 5.65139 2.66675 9.33329 2.66675ZM21.3333 15.1601C21.4978 16.2697 21.3083 17.403 20.7916 18.3988C20.275 19.3945 19.4575 20.202 18.4555 20.7063C17.4534 21.2107 16.3179 21.3862 15.2103 21.208C14.1028 21.0298 13.0796 20.5069 12.2864 19.7136C11.4932 18.9204 10.9703 17.8972 10.792 16.7897C10.6138 15.6822 10.7894 14.5466 11.2937 13.5446C11.7981 12.5426 12.6055 11.7251 13.6013 11.2084C14.597 10.6917 15.7303 10.5022 16.84 10.6667C17.9719 10.8346 19.0198 11.362 19.8289 12.1712C20.638 12.9803 21.1654 14.0282 21.3333 15.1601Z",
    stroke: "#EDEFEE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a4286c4852d8767f9cbb54928fd6fe80.svg";
export { ForwardRef as ReactComponent };